import Swup from 'swup';
import { gsap } from 'gsap';
import SplitType from 'split-type';

import SwupBodyClassPlugin from '@swup/body-class-plugin';

const swup = new Swup({
  animateHistoryBrowsing: true,
  timeout: 3000,
  containers: ['#swup', '#app-breadcrumb'],
  plugins: [new SwupBodyClassPlugin()],
});

/**
 * Bind listeners once (so Swup navigations don't stack listeners)
 */
let listenersBound = false;

function bindStaticListeners() {
  if (listenersBound) return;
  listenersBound = true;

  // Form submit spinner
  document.addEventListener('click', (e) => {
    const btn = e.target?.closest?.('.gform_button');
    if (!btn) return;

    const formBody = document.querySelector('.content');
    const formSpinner = document.querySelector('[spinner]');
    if (formSpinner) formSpinner.style.display = 'block';
    if (formBody) formBody.style.filter = 'grayscale(1)';
  });

  // Modal open/close (delegated)
  document.addEventListener('click', (e) => {
    const openBtn = e.target?.closest?.('[data-open-modal]');
    const closeBtn = e.target?.closest?.('[data-close-modal]');
    const modal = document.querySelector('[data-modal]');
    const gForm = document.querySelector('.gform_wrapper');

    if (!modal) return;

    if (openBtn) {
      modal.showModal();
      if (gForm) gForm.style.display = 'block';
    }

    if (closeBtn) {
      modal.close();
    }
  });
}

/**
 * Things that must be re-run after Swup swaps content
 */
function initPage() {
  // ---- JsBarcode: promo ----
  const promoEl = document.querySelector('#promobarcode');
  if (promoEl && typeof JsBarcode !== 'undefined') {
    const promocode = jQuery(promoEl).data('barcode');
    if (promocode) {
      try {
        JsBarcode('#promobarcode', promocode, {
          margin: 25,
          height: 105,
          width: 4,
          textMargin: 5,
        });
      } catch (err) {
        console.error('Promo barcode error:', err);
      }
    }
  }

  // ---- JsBarcode: standard ----
  const barcodeEl = document.querySelector('#barcode');
  if (barcodeEl && typeof JsBarcode !== 'undefined') {
    const barcode = jQuery(barcodeEl).data('barcode');
    if (barcode) {
      try {
        JsBarcode('#barcode', barcode, {
          margin: 20,
          textMargin: 5,
          height: 85,
          fontSize: 12,
        });
      } catch (err) {
        console.error('Barcode error:', err);
      }
    }
  }

  // ---- QRCodeJS (davidshimjs) ----
  const qrEl = document.getElementById('qrcode');
  if (qrEl) {
    const value = qrEl.dataset.qr || qrEl.getAttribute('data-qr') || '';
    if (value) {
      qrEl.innerHTML = ''; // important: library appends children
      if (typeof QRCode === 'undefined') {
        console.error('QRCode is undefined (qrcode.min.js not loaded globally)');
      } else {
        try {
          new QRCode(qrEl, {
            text: value,
            width: 128,
            height: 128,
            correctLevel: QRCode.CorrectLevel.M,
          });
        } catch (err) {
          console.error('QRCodeJS error:', err);
        }
      }
    }
  }

  // ---- Tilt ----
  const tiltEls = document.querySelectorAll('.tilt');
  if (tiltEls.length) {
    tiltEls.forEach((el) => {
      try {
        el.allTilt?.();
      } catch (err) {
        console.error('Tilt error:', err);
      }
    });
  }

  // ---- SplitType + GSAP animations ----
  // Always revert before re-splitting to avoid duplicated spans
  if (document.querySelector('h1.app-intro-header-word')) {
    try {
      SplitType.revert('h1.app-intro-header-word');
      const appHeaderWord = new SplitType('h1.app-intro-header-word', { types: 'words' });
      const words = appHeaderWord.words;

      gsap.fromTo(
        words,
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, stagger: 0.05, duration: 1, delay: 0.3, ease: 'power4.out' }
      );
    } catch (err) {
      console.error('SplitType words error:', err);
    }
  }

  if (document.querySelector('h1.app-intro-header')) {
    try {
      SplitType.revert('h1.app-intro-header');
      const appHeader = new SplitType('h1.app-intro-header', { types: 'chars' });
      const chars = appHeader.chars;

      gsap.fromTo(
        chars,
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, stagger: 0.05, duration: 1, delay: 0.4, ease: 'power4.out' }
      );
    } catch (err) {
      console.error('SplitType chars error:', err);
    }
  }

  // ---- Readonly field ----
  const readOnly = document.querySelector('li.gf_readonly input');
  if (readOnly) {
    readOnly.setAttribute('readonly', '');
  }

  // Bind any “once-only” listeners
  bindStaticListeners();
}

/**
 * Menu current item fix (before replace)
 */
function stripTrailingSlash(url) {
  return url.replace(/\/$/, '');
}

swup.hooks.before('content:replace', () => {
  const theUrl = stripTrailingSlash(window.location.pathname);
  const currentItems = document.querySelectorAll('#handheld-menu .current-menu-item');
  const newCurrentLink = document.querySelectorAll(`#handheld-menu a[href*="${theUrl}"]`);

  if (newCurrentLink.length > 0) {
    const curPar = newCurrentLink[0].closest('#handheld-menu .menu-item');
    if (curPar) {
      curPar.classList.add('current-menu-item', 'current_page_item');
    }
  }

  if (currentItems.length > 0) {
    currentItems[0].classList.remove('current-menu-item', 'current_page_item');
  }
});

/**
 * Initial load + Swup navigations
 */
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initPage();
} else {
  document.addEventListener('DOMContentLoaded', initPage);
}

swup.hooks.on('page:view', initPage);
